<div class="doc-container">

  <!-- Step 1: Intro -->
  <section *ngIf="currentStep === 1" class="intro-section">
    <div class="logo">
      <img src="./../../../assets/images/holcim_logo_color.svg" alt="Lafarge Logo" />
    </div>
   <h1 class="title">New Hire Documentation</h1>

<p>
  We have grouped the documents into two categories:
</p>

<h3>📘 Read Only</h3>
<p>
  These are policy documents provided for your information only. Please read them carefully.
</p>
<h5>
  <b>
    <a href="./../../../assets/New Hire Documentation - Policy Documents - Read Only.pdf" download>
      Download New Hire Documentation - Policy Documents - Read Only
    </a>
  </b>
</h5>

<h3>✍️ Fill & Sign Off</h3>
<p>
  The following forms are required to be filled, signed, and submitted as part of your onboarding:
</p>

<ol class="form-list">
  <li>Employee Data Processing Consent Form</li>
  <li>Payroll Data Form</li>
  <li>Background Check Consent Form</li>
  <li>HBM Nigeria Plc Voluntary Self-Declaration of Disability and Consent Form</li>
</ol>


    <div class="navigation">
      <button mat-raised-button color="primary" (click)="nextStep()">Next</button>
    </div>
  </section>

  <!-- Step 2: Payroll Data Form -->
  <section *ngIf="currentStep === 3" id="section-payroll" class="form-section">
     <div class="logo">
      <img src="./../../../assets/images/holcim_logo_color.svg" alt="Lafarge Logo" />
    </div>
    <div class="form-header">
      <h2 class="title">Payroll Data Form</h2>
      <div class="photo-box">
        <div class="photo-preview" *ngIf="passportPreview; else placeholder">
          <img [src]="passportPreview" alt="Passport" />
        </div>
        <ng-template #placeholder>
          <div class="photo-placeholder">Upload Photograph</div>
        </ng-template>
        <label class="upload-btn">
          <input type="file" (change)="onFileSelected($event)" hidden />
          Choose File
        </label>
      </div>
    </div>

    <form [formGroup]="payrollForm" class="styled-form">

  <!-- Personal Information -->
  <h3 class="section-title">Personal Information</h3>
  <div class="form-grid">
    <div class="form-row">
      <label>First Name</label>
      <input formControlName="firstName" type="text" />
    </div>

    <div class="form-row">
      <label>Other Names</label>
      <input formControlName="otherNames" type="text" />
    </div>

    <div class="form-row">
      <label>Surname at Birth</label>
      <input formControlName="surnameAtBirth" type="text" />
    </div>

    <div class="form-row">
      <label>Date of Birth</label>
      <input formControlName="dateOfBirth" type="date" />
    </div>

    <div class="form-row">
      <label>Title</label>
      <input formControlName="title" type="text" />
    </div>

    <div class="form-row">
      <label>Gender</label>
      <select formControlName="gender">
        <option value="">Select</option>
        <option>Male</option>
        <option>Female</option>
      </select>
    </div>

    <div class="form-row">
      <label>Designation</label>
      <input formControlName="designation" type="text" />
    </div>

    <div class="form-row">
      <label>Date of Resumption</label>
      <input formControlName="resumptionDate" type="date" />
    </div>

    <div class="form-row">
      <label>Marital Status</label>
      <select formControlName="maritalStatus">
        <option value="">Select</option>
        <option>Single</option>
        <option>Married</option>
      </select>
    </div>

    <div class="form-row">
      <label>Nationality</label>
      <input formControlName="nationality" type="text" />
    </div>

    <div class="form-row full-width">
      <label>Residential Address</label>
      <textarea formControlName="address" rows="2"></textarea>
    </div>

    <div class="form-row">
      <label>Phone</label>
      <input formControlName="phone" type="text" />
    </div>

    <div class="form-row">
      <label>Email</label>
      <input formControlName="email" type="email" />
    </div>

    <div class="form-row">
      <label>Bank</label>
      <input formControlName="bank" type="text" />
    </div>

    <div class="form-row">
      <label>Account Number</label>
      <input formControlName="accountNumber" type="text" />
    </div>

    <div class="form-row">
      <label>Next of Kin</label>
      <input formControlName="nextOfKin" type="text" />
    </div>
  </div>

  <!-- Education Background -->
  <h3 class="section-title">Educational Background</h3>
  <div formArrayName="education" class="dynamic-section">
    <div *ngFor="let edu of education.controls; let i = index" [formGroupName]="i" class="form-grid">
      <div class="form-row">
        <label>Degree</label>
        <input formControlName="degree" type="text" />
      </div>
      <div class="form-row">
        <label>Country</label>
        <input formControlName="country" type="text" />
      </div>
      <div class="form-row">
        <label>School</label>
        <input formControlName="school" type="text" />
      </div>
    </div>
    <button mat-stroked-button color="primary" type="button" (click)="addEducation()">+ Add More</button>
  </div>

  <!-- Languages -->
  <h3 class="section-title">Languages</h3>
  <div class="form-grid">
    <div class="form-row">
      <label>Language Spoken</label>
      <input formControlName="languageSpoken" type="text" />
    </div>
    <div class="form-row">
      <label>Language Written</label>
      <input formControlName="languageWritten" type="text" />
    </div>
  </div>

  <!-- Family Information -->
  <h3 class="section-title">Family Information</h3>
  <div formArrayName="family" class="dynamic-section">
    <div *ngFor="let fam of family.controls; let i = index" [formGroupName]="i" class="form-grid">
      <div class="form-row">
        <label>Name</label>
        <input formControlName="name" type="text" />
      </div>
      <div class="form-row">
        <label>Relationship</label>
        <input formControlName="relationship" type="text" />
      </div>
      <div class="form-row">
        <label>Date of Birth</label>
        <input formControlName="dob" type="date" />
      </div>
    </div>
    <button mat-stroked-button color="primary" type="button" (click)="addFamily()">+ Add More</button>
  </div>

  <!-- Experience -->
  <h3 class="section-title">Work Experience</h3>
  <div formArrayName="experience" class="dynamic-section">
    <div *ngFor="let exp of experience.controls; let i = index" [formGroupName]="i" class="form-grid">
      <div class="form-row">
        <label>Company</label>
        <input formControlName="company" type="text" />
      </div>
      <div class="form-row">
        <label>Starting Date</label>
        <input formControlName="startDate" type="date" />
      </div>
      <div class="form-row">
        <label>Ending Date</label>
        <input formControlName="endDate" type="date" />
      </div>
      <div class="form-row">
        <label>Job Title</label>
        <input formControlName="jobTitle" type="text" />
      </div>
    </div>
    <button mat-stroked-button color="primary" type="button" (click)="addExperience()">+ Add More</button>
  </div>

  <!-- Navigation -->
  <div class="navigation">
    <button mat-stroked-button color="accent" (click)="prevStep()">Back</button>
    <button mat-raised-button color="primary" (click)="savePayroll()" [disabled]="!payrollForm.valid">
      Next
    </button>
  </div>
</form>

  </section>
  <!-- Step X: Policy Agreement -->
<section *ngIf="currentStep === 2" id="section-policy">
   <div class="logo">
      <img src="./../../../assets/images/holcim_logo_color.svg" alt="Lafarge Logo" />
    </div>
  <h2 class="title">Data Protection & Privacy Policy</h2>

  <div class="policy-text">
    <p>
      I hereby give consent to Lafarge Africa Plc (“Lafarge”) to collect, process and
      retain my personal data that I have provided and further agree that Lafarge may
      share such data with third parties, including but not limited to: Lafarge Africa Plc,
      LafargeHolcim Group, Service Providers, Regulatory Agencies, and any other
      persons/parties that Lafarge Africa Plc is legally obligated to disclose my personal
      data to, within and outside Nigeria.
    </p>
    <p>
      I understand that my personal data will be used for employment related
      purposes, including payroll administration, benefits administration, health
      insurance, pension, and compliance with regulatory requirements.
    </p>
    <p>
      I am aware that I can withdraw this consent at any time by sending an email to
      <a href="mailto:ng-m-dataprotection@ng.huaxin.com">
        ng-m-dataprotection@ng.huaxin.com
      </a>,
      and that such withdrawal will not affect the lawfulness of processing based on
      consent before its withdrawal.
    </p>
    <p>
      I affirm that I have been informed of my rights under the Nigeria Data Protection
      Regulation (NDPR) and any applicable data protection laws, and I consent to the
      processing of my personal data as described above.
    </p>
  </div>

  <!-- Confirmation -->
  <div class="form-row checkbox-row">
    <mat-checkbox [(ngModel)]="policyConfirmed" name="policyConfirmed">
      I hereby affirm that I have read, understood, and agreed to the policy.
    </mat-checkbox>
  </div>

  <!-- Show name + date once confirmed -->
  <div *ngIf="policyConfirmed" class="confirmation-details">
    <p><strong>Confirmed by:</strong> {{ name }}</p>
    <p><strong>Date:</strong> {{ today | date:'longDate' }}</p>
  </div>

  <!-- Navigation -->
  <div class="navigation">
    <button mat-stroked-button color="accent" (click)="prevStep()">Back</button>
    <button mat-raised-button color="primary" (click)="nextStep()" [disabled]="!policyConfirmed">
      Next
    </button>
  </div>
</section>
<!-- Step 4: Background Screening Consent -->
<section *ngIf="currentStep === 4" id="section-background" class="consent-section">
  <div class="logo">
      <img src="./../../../assets/images/holcim_logo_color.svg" alt="Lafarge Logo" />
    </div>
  <h2 class="title">Consent to Background Screening</h2>

  <!-- Long consent text -->
  <div class="consent-text">
    <p>
      I understand that in connection with my Employment with <b>LAFARGE AFRICA PLC</b>, its consultant,
      <b>FORT KNOX VERIFICATION AND CHECKS SERVICES LIMITED</b>, would be conducting a background check
      on me. This background check may include inquiries into my Employment History, Education, Professional
      Certifications, General Character or Reputation, Work Experience, Driving, and/or Criminal History,
      Credit History, family background and any other information required for background screening
      (“Personal Information”).
    </p>
    <p>
      I understand that LAFARGE AFRICA PLC may rely on any part or all of this Information obtained during
      the checks in determining whether or not to confirm my appointment.
    </p>
    <p>
      I also understand that the background check is not conducted for any purpose other than in connection
      with my Employment with LAFARGE AFRICA PLC.
    </p>
    <p>
      I have read this Background Screening consent document and by signing below, hereby authorize the
      background screeners to conduct checks as described herein.
    </p>
    <p>
      I hereby release the consultant, any and all the screeners together with LAFARGE AFRICA PLC, from
      any and all liability related to the procurement or disclosure of the Personal Information provided by me
      or obtained about me.
    </p>
    <p>
      I further authorize any third parties who are custodians of or in possession of the Personal Information, to
      disclose such to FORT KNOX VERIFICATION AND CHECKS SERVICES LIMITED.
    </p>
    <p><i>Thank you.</i></p>
  </div>

  <!-- Background consent form -->
  <form [formGroup]="backgroundForm" class="styled-form">

    <div class="form-grid">
      <div class="form-row">
        <label>Surname</label>
        <input formControlName="surname" type="text" />
      </div>

      <div class="form-row">
        <label>Other Name(s)</label>
        <input formControlName="otherNames" type="text" />
      </div>

      <div class="form-row">
        <label>Date of Birth</label>
        <input formControlName="dob" type="date" />
      </div>

      <div class="form-row full-width">
        <label>Residential Address</label>
        <textarea formControlName="address" rows="2"></textarea>
      </div>

      <div class="form-row">
        <label>Matriculation No</label>
        <input formControlName="matricNo" type="text" />
      </div>

      <div class="form-row">
        <label>Email</label>
        <input formControlName="email" type="email" />
      </div>

      <div class="form-row">
        <label>Phone Number(s)</label>
        <input formControlName="phone" type="text" />
      </div>

      <div class="form-row full-width">
        <label>Reference 1 (Name, Email & Phone Number)</label>
        <textarea formControlName="ref1" rows="2"></textarea>
      </div>

      <div class="form-row full-width">
        <label>Reference 2 (Name, Email & Phone Number)</label>
        <textarea formControlName="ref2" rows="2"></textarea>
      </div>

      <div class="form-row">
        <label>Witness Name</label>
        <input formControlName="witness" type="text" />
      </div>
    </div>

    <!-- Consent checkbox -->
    <div class="form-row checkbox-row">
      <mat-checkbox formControlName="consent" >
        I hereby authorize and consent to the background checks as stated above.
      </mat-checkbox>
    </div>

    <!-- Signature -->
    <div *ngIf="backgroundForm.get('consent')?.value" class="signature-block">
      <p><b>Signed by:</b> {{ name }}</p>
      <p><b>Date:</b> {{ today | date: 'longDate' }}</p>
    </div>

    <!-- Navigation -->
    <div class="navigation">
      <button mat-stroked-button color="accent" (click)="prevStep()">Back</button>
      <button mat-raised-button color="primary" (click)="nextStep()" 
              [disabled]="!backgroundForm.valid ">
        Next
      </button>
    </div>
  </form>
</section>
<!-- Step 5: Group Life Beneficiary & Emergency Contact -->

<section *ngIf="currentStep === 5" id="section-disability" class="Disability-section">
    <div class="logo">
      <img src="./../../../assets/images/holcim_logo_color.svg" alt="Lafarge Logo" />
    </div>
  <h2 class="title">LAFARGE AFRICA PLC VOLUNTARY SELF-DECLARATION OF DISABILITY AND CONSENT FORM</h2>
  <form [formGroup]="disabilityForm" (ngSubmit)="saveDisability(); submitAll()">

    <p class="subtitle">
      I hereby voluntarily consent and authorize Lafarge Africa PLC (the” Company”) to collect and process
      my personal data (including my name, and email address) and sensitive personal data (disability
      record) for the purpose indicated below.
    </p>

    <h3 class="subtitle">Why are you being asked to complete this form (Purpose of Processing)</h3>
    <p class="subtitle">
      By law, the Company is required to make reasonable adjustment to support any employee or visitor
      on our premises with a disability.
    </p>

    <h3 class="subtitle">Right of Refusal</h3>
    <p class="subtitle">
      Completing this form is voluntary. Your response will be kept private and not used against you in any
      way, in compliance with the Nigeria Data Protection Act.
    </p>

    <h3 class="subtitle">What is a disability?</h3>
    <p class="subtitle">
      A disability is a physical or mental impairment or medical condition that substantially limits a major
      life activity, it includes history or record of such an impairment or medical condition.
    </p>

    <!-- Disability Checkboxes -->
    <div class="form-row checkbox-row">
      <mat-radio-group formControlName="hasDisability">
        <mat-radio-button value="yes">YES, I HAVE A DISABILITY (or previously had a disability)</mat-radio-button>
        <mat-radio-button value="no">NO, I DON’T HAVE A DISABILITY</mat-radio-button>
        <mat-radio-button value="na">I DON’T WISH TO ANSWER</mat-radio-button>
      </mat-radio-group>
    </div>

    <!-- If YES, show extra fields -->
    <div *ngIf="disabilityForm.get('hasDisability')?.value === 'yes'" class="conditional-section">
      <div class="form-row">
        <label>What is the nature of your condition(s)?</label>
        <textarea formControlName="conditionDetails" rows="3"></textarea>
      </div>

      <div class="form-row">
        <label>What adjustments have been made for you, or recommended, in the past?</label>
        <textarea formControlName="pastAdjustments" rows="3"></textarea>
      </div>
    </div>

    <!-- Footer -->
    <p>
      I understand completely that the Company shall process my personal data as provided in accordance
      with the Company’s data protection policy available here.
    </p>

    <div class="form-grid">
      <div class="form-row">
        <label>Names</label>
        <input formControlName="names" type="text" />
      </div>

      <div class="form-row">
        <label>Email Address</label>
        <input formControlName="email" type="email" />
      </div>

      <div class="form-row">
        <label>Date</label>
        <input formControlName="date" type="date" />
      </div>
    </div>

    <div class="form-row">
      <label>Signature</label>
      <input type="text" formControlName="signature" placeholder="Type your full name as signature" />
    </div>

    <!-- Navigation -->
    <div class="navigation">
      <button mat-stroked-button color="accent" (click)="prevStep()">Back</button>
      <button mat-raised-button color="primary" (click)="saveDisability()" [disabled]="!disabilityForm.valid">
        Submit
      </button>
    </div>
  </form>
</section>

<!-- Step 7: Confirmation (new) -->
<section *ngIf="currentStep === 6" id="section-complete" class="confirmation-section">
  <div class="logo">
    <img src="./../../../assets/images/holcim_logo_color.svg" alt="Lafarge Logo" />
  </div>

  <h2 class="title">Submission Received</h2>
  <p>Your documents have been captured and submitted. We will process them and get back to you.</p>

  <!-- <div class="navigation">
    <button mat-raised-button color="primary" (click)="goToStart()">Start Over</button>
  </div> -->
</section>
</div>
